import axios from "axios";
import { v4 as uuidv4 } from "uuid";
import CryptoJS from "crypto-js";
import store from "../store/store";
import { getDecryptedItem } from "../utils/localStorageHelper";
import { getDecryptedSessionItem, setEncryptedSessionItem } from "./helper";

export const API = {
  LOGIN: {
    GET_TOKEN: "/token",
    GOOGLE_TOKEN: "/google-token",
  },
  USER: {
    GET_USER_PROFILE: "get-user-name",
    PROFILE_CHECK: "/profile-check",
  },
  ACCOUNT_DETAILS: {
    GET_ACCOUNT_BALANCE: "get-account-balance",
  },
  BALANCE: {
    CHECK_SUFFICIENT_BALANCE: "check-sufficient-balance",
  },
  TERMS: {
    GET_TERMS_CONDITIONS: "get-terms-conditions",
  },
  CALL_SETTINGS: {
    SAVE_DISCONNECTED_TIME: "save-disconnect-time",
    GET_DISCONNECTED_TIME: "get-disconnect-time",
  },
  CAMPAIGN: {
    CAMPAIGN: "campaign",
    CAMPAIGN1: "/campaigns",
    CAMPAIGN_RUNS: "/run-campaign",
    CAMPAIGN_RUNS_DETAILS: "/run-campaign-details",
    CAMPAIGNS_WIDGET_COUNT: "/campaign-widgets",
    CAMPAIGNS_RUNS_WIDGET_COUNT: "/campaign-run-dashboard",
    CAMPAIGNS_RUNS_DETAILS_WIDGET_COUNT: "/campaign-run-details-widgets",
    EXCEL_EXPORT: "/excel-export",
    SAVE_FILTERED_CAMPAIGN: "/save-filtered-campaign",
    SCHEDULE_CAMPAIGN: "/schedule-call",
  },
  AUDIENCE: {
    AUDIENCE: "/audience",
    EXCEL_AUDIENCE: "/audience-excel",
  },
  PAYMENT: {
    SAVE_PAYMENT: "/topup",
    UPDATE_PAYMENT: "/stripe/balance",
    INVOICE: "/invoice",
    ORDER: "/razorpay/order",
    VERIFY: "/razorpay/verify",
  },
  V1: {
    CRM: {
      LOGIN: "/crm/login",
      WHITELABELDETAILS: "/whiteLabelDetails",
      CONNECTION_CHECK: "/crm/ghl/account-status",
      ACCOUNT_CHECK: "/crm/signup/subaccount",
    },
    VOICE: {
      VOICE: "/voices",
      VOICE_CLONE: "/voice/clone",
    },
    ACCESS: {
      INVITE: "/invite",
      USERS_CHECK: "/users/check",
      ACCEPT_INVITE: "/invite/accept",
      INVITED_USERS: "/invite/users",
      INVITE_USER: "/invite/user",
      ACCOUNT_HISTORY: "/account-history",
      SEND_EMAIL: "/user/sendEmail",
      PAUSE_ACCOUT: "/account-status",
      DELETE_ACCOUNT: "/accounts",
    },
    ADMIN: {
      GET_ALL_USER_LIST: "/users",
      GET_ALL_USER_USAGE_LIST: "/spent-history",
      RECHARGE: "/recharge/manual",
      SET_PRICING: "/account/price",
      GET_API_KEY: "/apikey",
      MASTER_PASSWORD: "/user/passwords",
      RECHARGE_HISTORY: "/account-balance-history",
      ACCOUNT_CREDIT: "/request-balance",
    },
    COMMON: {
      PAYMENT_ENQ: "/payment-enquiry",
      VERIFY_EMAIL: "/verify-email",
      USER: "/user",
      LOGIN: "/login",
      GET_USER_ACCOUNTS_DETAILS: "/user/accounts",
      SYSTEM_CONSTANT: "/system-constant",
      PROFILE_CHECK: "/profile-check",
      DASHBOARD: "/dashboard",
      DASHBOARD_CHART: "/dashboard/chart",
      CHECK_AUTH: "/auth/check",
      RESET_PASSWORD: "/reset-password/email",
      UPDATE_PASSWORD: "/reset-password/update",
      GOOGLE_LOGIN: "/google-login",
      LAST_LOGIN_TRACK: "/user/track",
      DEFAULT_GATEWAY: "/default-gateway",
      FEEDBACK: "/add-feedback",
      GENERATE_CODE: "/verification/generate",
      VERIFY_CODE: "/verification/verify",
      MULTIPLE_UPLOAD: "/voices/multiple",
    },
    PROJECT: "/project",
    PROJECT_CLONE: "/project/clone",
    PROJECTS_COUNT: "/project/calls/count",
    ACCOUNT: "/account",
    RECORDING: {
      RECORDING: "/recording",
      TRACK: "/recording/track",
    },
    AUDIENCE: {
      AUDIENCE: "/audience",
      AUDIENCE_EXCEL: "/audience/excel",
      SELECT_AUDIENCE: "/audienceList-count",
    },
    AI: {
      CHECK_PROMPT: "/prompt/param_checker",
      QUEUE: "/system/queue",
      LOGS: "/cloud/public/logs",
      QUEUE_LIST: "/system/all_queue",
      UPDATE_LIST: "/system/queue",
      CALLS_LIST: "/system/accounts/calls",
      GATEWAY_CALLS_LIST: "/system/sid/calls",
      GATEWAY_PLUS_ACCOUNT_CALLS_LIST: "/system/sid_account/calls",
      INCREASE_CPS: "/gateways/cps",
      INCREASE_CAPACITY: "/gateways/trunk_capacity",
      PAUSE_GATEWAY: "/gateways/on_prem/gateway/pause",
      PAUSE_SERVER: "/gateways/on_prem/server/pause/",
      SERVER_DETAILS: "/gateways/on_prem/server",
      GATEWAY_ASSIGNED_NUMBERS: "/twilio/gateway_phone_numbers",
      SAVE_INBOUND_NUMBER: "/twilio/select-incoming-number",
      GATEWAY_LIST: "/system/botstream_queue",
      GATEWAY_ACTION: "/gateways/action",
      CALL_GRAPH: "/system/call_graph",
      CLEAR_QUEUE: "/gateways/clear/emergency",
      SWITCH_GATEWAY: "/gateways/logical_gateway",
      CLEAR_REFERENCE_QUEUE: "/call/inbound_details",
      LEAD_SEARCH: "/analyze/get_matching_entries",
      FUNCTION_EXECUTE: "/functions/execute",
      RAG_QUESTIONS: "/agents/rag_questions",
      RAG_GENERATE_QUESTIONS: "/agents/generate_questions",
      GATEWAY_STATUS: "/system/gateway_details",
      GET_GATEWAY_LISTS: "/gateways/gateways",
      UPDATE_GATEWAY_LISTS: "/system/gateway_config",
      PROJECT_WISE_QUEUE_COUNT: "/system/db_url_project_wise_calls",
    },
    TWILLIO: {
      SAVE_SID: "/twilio/register/auth",
      CREATE_TRUNK: "/twilio/create/trunk",
      LIST_BUYED_NUMBERS: "/twilio/phone_numbers",
      LIST_NUMBER_TO_BUY: "/twilio/phone_numbers/buy",
      COUNTRIES_LIST: "/twilio/list/countries",
      PURCHASE_PHONE_NUMBER: "/twilio/phone_number/buy",
    },

    AGENT: {
      AGENT: "/agent-setting",
      DEFAULT_SET: "/default-agent",
      AGENT_OBJECTION: "/prompt/generate_objections",
      CHAT_ID: "/prompt/prompt",
      CHAT: "/chat/chat",
      ONBOARDING_CHAT: "/prompt/onboarding/chat",
      IMPORT_AGENT: "/agent/import",
      GENERATE_PROMPT: "/prompt/generate/agent",
      GENERATE_VOICE: "/voice/generate",
      GENERATE_SCENARIOS: "/agents/generate-scenarios",
      CHAT_TEST_AGENT: "/chat/chat/test_agent",
      TEST_AGENT_PROGRESS: "/chat/chat/test_agent_progress",
      GET_TEST_AGENT_PROGRESS: "/chat/chat/test_agent_progress_by_agent_id",
      EMAIL_CONVERSATIONS: "/getEmailConversation",
      EMAIL_DATA: "/email-data",
      SMS_DATA: "/sms-data",
      DEMO_BOT: "/demobot",
      GET_DEMO_BOT: "/getdemobot",
      GET_AGENT_VERSION: "/agent-setting-versions",
    },
    CAMPAIGN: {
      CAMPAIGN: "/campaigns",
      CALL_HISTORY: "/campaign-run/details/daily",
      CALL_HISTORY_COUNT: "/campaign-run/details/count/daily",
      CAMPAIGN_COUNT: "/campaigns-count",
      TRIGGER_CAMPAIGN: "/trigger-campaign",
      TRIGGER_ASSESSMENT_CALL: "/trigger-assessment-call",
      CHECK_CAMPAIGN_VALIDATION: "/campaigns-validation",
      CAMPAIGN_RUNS: "/campaign-runs",
      CAMPAIGN_RUNS_COUNT: "/campaign-run-count",
      STOP_CAMPAIGN_RUNS: "/campaign-runs/stop",
      SCHEDULE_CAMPAIGN: "/schedule-call",
      CAMPAIGN_DETAILS: "/campaign-run/details",
      EXCEL_EXPORT: "/excel-export",
      FILTERED_CAMPAIGN: "/save-filtered-campaign",
      SAVE_MANUAL_FIELDS: "/manual-fields/excel",
      EXISTING_EXCEL: "/manual-fields/excel",
      SAVE_INSIGHTS: "/insights",
      ALL_DETAILS: "/campaign/run-details",
      TRIGGER_CALL_DIRECTLY: "/trigger-call",
      CAMPAIGN_RUNS_LIVE: "/campaign-runs/live",
      REFRENCE_ADD: "/custom-dialer/reference",
      ENTITIES: "/prompt/entities",
      ENTITIES_LIST: "/prompt/entities/list",
      ANALYZE_TRANSCRIPT: "/analyze/transcript",
      ANALYZE_SUMMARY: "/analyze/summary",
    },
    INSIGHTS: "/insights/all",
    WHATSAPP: "/whatsapp/msg",
    SMS: "/sms/msg",
    CALL_SETTINGS: {
      CALL_SETTINGS: "/call-settings",
      GET_VOXI_OTP: "/get-otp",
      RESEND_OTP: "/resend-otp",
      VERIFY_OTP: "/verify-otp",
      BYOC: "/byoc",
    },
    GOOGLE_INTEGRATION: "/google/callback",
    ADVANCE_SETTINGS: "/advance-settings",
    CHECK_ACCOUNT_NAME: "/account/check-name",
    PAYMENT: {
      SAVE_PAYMENT: "/topup",
      UPDATE_PAYMENT: "/stripe/balance",
      INVOICE: "/invoice",
      ORDER: "/razorpay/order",
      VERIFY: "/razorpay/verify",
      STRIPE_CHECKOUT: "/stripe/create-checkout-session",
      STRIPE_BILLING_PORTAL: "/stripe/billing-session",
    },
    APPOINTMENT: {
      APPOINTMENT: "/appointment-settings",
    },
    WHATSAPP: {
      ADD_WHATSAPP_ACCOUNT: "/whatsapp/account/add",
      GET_WHATSAPP_ACCOUNTS: "/whatsapp/get_business_id_list_details",
      GET_WHATSAPP_ACCOUNT: "/whatsapp/get_business_id_detail",
      CREATE_WHATSAPP_TEMPLATE: "/whatsapp/templates",
    },
    LEAD: {
      LEADS: "/lead-data",
      EXCEL_LEAD_DATA: "/excel/lead-data",
      WORKFLOW_LEAD_DATA: "/workflow/lead-data",
    },
    GOOGLE_SHEETS: {
      GET_DATA: "/google-sheet/filter",
      GET_SHEET_DATA: "/google/sheets",
    },
    WORKFLOW: {
      WORKFLOW_DATA: "/workflowData",
      ADD_CONTACTS_TO_WORKFLOWS: "/add-to/workFlow",
    },
    CELERY_TASKS: "/celery/tasks",
    CELERY_TASKS_PROMOTE: "/celery/task/promote",
    DNC: "/dncList",
    TEST_CUSTOMER: "/test-customer",
  },
};
const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const BASE_URL_API_LINK = process.env.REACT_APP_BASE_URL_API;
export const BASE_URL_AI = `${process.env.REACT_APP_BASE_URL_AI}`;
export const BASEURL = `${BASE_URL}`;
export const BASE_URL_API = `${BASE_URL_API_LINK}`;
export const BASE_URL_API_V1 = `${process.env.REACT_APP_BASE_URL_API_V1}`;

(function isEncrypted() {
  const urlParams = new URLSearchParams(window.location.search);
  const e2e = urlParams.get("txnEnable");
  const now = Date.now();
  const DISABLE_UUID = "bce9d8e64a5142b19d22";

  if (e2e !== null) {
    const enabled = e2e === DISABLE_UUID && false;
    setEncryptedSessionItem("e2eInfo", { enabled, timestamp: now });
  } else {
    setEncryptedSessionItem("e2eInfo", { enabled: true, timestamp: now });
  }
})();

async function aesEncrypt(data, key) {
  return CryptoJS.AES.encrypt(JSON.stringify(data), key).toString();
}

async function rsaEncrypt(plainText, publicKeyPem) {
  // Convert PEM key to ArrayBuffer
  const binaryDerString = atob(
    publicKeyPem.replace(/-----.*?-----/g, "").replace(/\n/g, "")
  );
  const binaryDer = new Uint8Array(binaryDerString.length);
  for (let i = 0; i < binaryDerString.length; i++) {
    binaryDer[i] = binaryDerString.charCodeAt(i);
  }

  // Import the RSA public key
  const publicKey = await window.crypto.subtle.importKey(
    "spki",
    binaryDer.buffer,
    {
      name: "RSA-OAEP",
      hash: "SHA-256",
    },
    false,
    ["encrypt"]
  );

  // Encode plain text as ArrayBuffer
  const encoder = new TextEncoder();
  const dataBuffer = encoder.encode(plainText);

  // Encrypt the data
  const encryptedBuffer = await window.crypto.subtle.encrypt(
    {
      name: "RSA-OAEP",
    },
    publicKey,
    dataBuffer
  );

  // Convert encrypted data to Base64 for transport
  return btoa(String.fromCharCode(...new Uint8Array(encryptedBuffer)));
}

async function encryptData(data, uuid) {
  const encryptedData = await aesEncrypt(data, uuid);
  return encryptedData;
}

async function aesDecrypt(payload, key) {
  try {
    const bytes = CryptoJS.AES.decrypt(payload, key);
    return JSON.parse(bytes?.toString(CryptoJS.enc.Utf8));
  } catch (error) {
    console.error("Decryption error:", error);
    return null;
  }
}

export const axiosClient = axios.create();
let token = getDecryptedItem("token");
let selectedAccount = getDecryptedItem("selectedAccount");
axiosClient.defaults.headers.common["Authorization"] = `Bearer ${token}`;
axiosClient.defaults.headers.post["Content-Type"] = "application/json";
axiosClient.defaults.headers.common["dbUrl"] = `${selectedAccount?.accountUrl}`;

axiosClient.interceptors.request.use(
  async (config) => {
    const publicKey = store.getState()?.AccountReducer?.publicKey;
    const now = Date.now();
    const EXPIRY_MINUTES = 10;
    let isE2EEnabled = true;

    const stored = getDecryptedSessionItem("e2eInfo");

    if (stored) {
      if (now - stored.timestamp <= EXPIRY_MINUTES * 60 * 1000) {
        isE2EEnabled = stored.enabled;
      } else {
        sessionStorage.removeItem("e2eInfo");
      }
    }

    if (isE2EEnabled) {
      if (publicKey) {
        const uuid = uuidv4();
        const rsaEncryptedUuid = await rsaEncrypt(uuid, publicKey);

        config.headers["x-api-headers"] = rsaEncryptedUuid;
        config.metadata = { aesKey: uuid };

        if (config?.params) {
          const encryptedParams = await encryptData(config.params, uuid);
          config.params = { data: encryptedParams };
        }

        if (config?.data) {
          if (config.data instanceof FormData) {
            const formDataObj = new FormData();
            const payloadData = {};

            for (let [key, value] of config.data.entries()) {
              if (value instanceof File) {
                formDataObj.append(key, value);
              } else {
                payloadData[key] = value;
              }
            }

            const encryptedData = await encryptData(payloadData, uuid);
            formDataObj.append("data", encryptedData);
            config.data = formDataObj;
            config.headers["Content-Type"] = "multipart/form-data";
          } else {
            const encryptedBody = await encryptData(config.data, uuid);
            config.data = { data: encryptedBody };
          }
        }
      }
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axiosClient.interceptors.response.use(
  async (response) => {
    const aesKey = response.config?.metadata?.aesKey;
    if (response.data?.data && aesKey) {
      response.data = await aesDecrypt(response.data.data, aesKey);
    }
    return response;
  },
  async (error) => {
    if (error.response) {
      const aesKey = error.response.config?.metadata?.aesKey;
      if (error.response.data.data && aesKey) {
        error.response.data = await aesDecrypt(
          error.response?.data?.data,
          aesKey
        );
      }
      const status = error?.response?.status;
      const message = error?.response?.data?.detail || "Something went wrong";

      console.log("Response status:", status);
      console.log("Response data:", error.response);
      console.log("Response message:", error.response.data.msg);

      if (status === 403) {
        Object.keys(localStorage).forEach((key) => {
          if (key !== "pay-redirection") {
            localStorage.removeItem(key);
          }
        });
        if (window?.location?.pathname !== "/") window.location.href = "/";
        return;
      }
      return error?.response;
    }
  }
);
